import { PictureList, QYPlatformList, Zone } from "project-config/constants";
import { useQuery } from "react-query";
import { isFox } from "@/utils/isFox";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "@/store/GlobalStore";

interface IPlatform {
  isShow: number;
  name: string;
  platform: number;
  status: number;
  taskPrefix: string;
  type: number;
  chineseName: string;
  englishName: string;
  //
  label: string;
  aiPlatform: number;
  isAllowedSubmit: boolean;
}

export function usePlatformList() {
  const [platformList, setPlatformList] = useState<IPlatform[]>([]);
  const { isZh } = useGlobalStore();

  const { data } = useQuery<IPlatform[]>([
    "/api/rendering/task/common/getPlatformStatus",
    { zone: isFox() ? Zone.Foreign : Zone.Domestic },
  ]);

  const { t } = useTranslation("common");
  useEffect(() => {
    let pList = data;

    const isMigu = false;
    if (isMigu) {
      const forbidPlatformList = [...PictureList, ...QYPlatformList];
      pList = data?.filter((key) => {
        return !forbidPlatformList.includes(key.platform);
      });
    }

    // 国外用户 过滤 效果图平台
    if (isFox()) {
      pList = pList?.filter((key) => key.platform !== 5);
    }

    pList = pList?.map((item) => ({
      ...item,
      label: isZh ? item.chineseName : item.englishName,
    }));

    setPlatformList(pList ?? []);
  }, [data, t, isZh]);

  return { platformList };
}
